import { React, PropTypes } from 'imports';
import SpinJS from 'spin.js';
import { deepEqual } from 'utils';
import common from '!!less-vars-loader!static/common.less';
import './Spinner.less';

export const DEFAULT_CONFIG = {
    color: '#000000',
    lines: 13,
    length: 28,
    width: 14,
    radius: 42,
    corners: 1,
    opacity: 0.25,
    rotate: 0,
    direction: 1,
    speed: 1,
    trail: 60,
    fps: 20,
    zIndex: 2e9,
    className: 'spinner-internal',
    top: '50%',
    left: '50%',
    shadow: false,
    hwaccel: false,
    position: 'absolute'
};

export const INITIAL_SIZE = 170; //px

export default class Spinner extends React.Component {

    static get DEFAULT_CONFIG() {
        return DEFAULT_CONFIG;
    }

    static get INITIAL_SIZE() {
        return INITIAL_SIZE;
    }

    static get propTypes() {
        return {
            config: PropTypes.object,
            className: PropTypes.string,
            tagName: PropTypes.string,
            showTimeout: PropTypes.number,
            changeTimeout: PropTypes.number
        }
    }

    static get defaultProps() {
        return {
            config: DEFAULT_CONFIG,
            tagName: 'div',
            className: '',
            showTimeout: 100,
            changeTimeout: 10000
        }
    }

    static get contextTypes() {
        return {
            parent: PropTypes.object
        }
    }

    _spinner = null;

    state = { visible: false, changed: false }

    componentDidMount() {
        // a dirty trick to know when Spinner is rendered inside a Popup - if it is then it most likely affects Popup's size and delayed rendering causes Popup to jump
        if (this.props.showTimeout > 0 && !this.context.parent) {
            this._showTimeoutID = setTimeout(this._onShowTimeout, this.props.showTimeout);
        } else {
            this._onShowTimeout();
        }
        if (this.props.changeTimeout > 0) {
            this._changeTimeoutID = setTimeout(this._onChangeTimeout, this.props.changeTimeout);
        } else {
            this._onChangeTimeout();
        }

        this._start();
    }

    shouldComponentUpdate(nextProps, nextState) {
        return !deepEqual(this.props, nextProps) || !deepEqual(this.state, nextState);
    }

    componentDidUpdate(prevProps, prevState) {
        this._stop();

        this._start();
    }

    componentWillUnmount() {
        this._stop();

        if (this._showTimeoutID) {
            clearTimeout(this._showTimeoutID);
        }
        if (this._changeTimeoutID) {
            clearTimeout(this._changeTimeoutID);
        }
    }

    _start() {
        if (this.state.visible) {
            const config = { ...DEFAULT_CONFIG, ...this.props.config };

            if (this.state.changed) {
                config.color = common.colorPrimary;
            }

            this._spinner = new SpinJS(config);
            this._spinner.spin(this.refs.container);
        }
    }

    _stop() {
        if (this._spinner) {
            this._spinner.stop();
            this._spinner = null;
        }
    }

    _onShowTimeout = () => {
        this.setState({ visible: true });
    }

    _onChangeTimeout = () => {
        this.setState({ changed: true });
    }

    render() {
        let Tag = this.props.tagName,
            config = { ...DEFAULT_CONFIG, ...this.props.config },
            style = {};

        style['minWidth'] = style['minHeight'] = this.state.visible ? `${INITIAL_SIZE * (config.scale || 1)}px` : '';

        return (
            <Tag style={style}
                className={`spinner ${!this.state.visible ? 'hidden' : !this.state.changed ? 'visible' : 'changed'} ${this.props.className}`}>
                {this.state.visible ? <span ref="container" /> : null}
            </Tag>
        )
    }
}